var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 717,
    height: 716,
    viewBox: "0 0 717 716",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73497 689.953C18.7555 706.269 36.2111 716 55.2498 716H661.338C680.515 716 697.834 706.27 707.853 689.953C717.874 673.783 718.876 653.887 710.286 636.86L407.158 30.7714C397.856 12.1677 379.107 0.571991 358.355 0.571991C337.465 0.571991 318.716 12.1683 309.407 30.7714L6.27865 636.86C-2.15901 653.888 -1.30206 673.783 8.71843 689.953H8.73497ZM407.856 645.405C407.856 653.305 401.451 659.717 393.544 659.717H323.081C315.181 659.717 308.769 653.313 308.769 645.405V574.942C308.769 567.042 315.173 560.631 323.081 560.631H393.551C401.451 560.631 407.863 567.035 407.863 574.942L407.856 645.405ZM296.148 222.045C298.842 219.177 302.618 217.55 306.561 217.55H410.071C414.014 217.55 417.789 219.177 420.483 222.045C423.184 224.913 424.593 228.776 424.354 232.712L407.834 510.707C407.384 518.266 401.125 524.177 393.551 524.177L323.081 524.17C315.508 524.17 309.248 518.266 308.798 510.7L292.279 232.704C292.039 228.769 293.441 224.913 296.149 222.045H296.148Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c48b345ad13d49ce7d90f0806c638445.svg";
export { ForwardRef as ReactComponent };